import { useAuth } from '@clerk/react';
import { type ReactElement } from 'react';
import { useCatalogLiveAuth, useCatalogLiveSignedIn } from '../hooks/useCatalogLiveAuth';

function SignedInCatalogLive(): null {
  useCatalogLiveSignedIn();
  return null;
}

/** Keeps catalog entitlement mounted so sign-out can clear the live session. */
export default function CatalogLiveAuth(): ReactElement | null {
  const { isLoaded, isSignedIn } = useAuth();
  useCatalogLiveAuth();
  if (!isLoaded || !isSignedIn) return null;
  return <SignedInCatalogLive />;
}
